import {CheckOutlined, ClockCircleOutlined, CloseOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {DocumentFieldsFragment, DocumentStatus, Maybe} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  document?: Maybe<DocumentFieldsFragment>;
}

export const DocumentStatusTag: React.FC<Props> = ({document, ...props}) => {
  if (!document) return null;
  switch (document.status) {
    case DocumentStatus.APPROVED:
      return (
        <StatusTag {...props} color={colors.success}>
          Approved <CheckOutlined />
        </StatusTag>
      );
    case DocumentStatus.APPROVAL_REQUIRED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Approval required <ClockCircleOutlined />
        </StatusTag>
      );
    case DocumentStatus.PROCESSING:
      return (
        <StatusTag {...props} color={colors.grey}>
          Processing <ClockCircleOutlined />
        </StatusTag>
      );
    case DocumentStatus.PENDING:
      return (
        <StatusTag {...props} color={colors.grey}>
          Pending <ClockCircleOutlined />
        </StatusTag>
      );
    case DocumentStatus.REJECTED:
      return (
        <StatusTag {...props} color={colors.error}>
          Rejected <CloseOutlined />
        </StatusTag>
      );
    case DocumentStatus.EXPIRED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Expired <CloseOutlined />
        </StatusTag>
      );
  }

  return null;
};
